import tripEvents from '../config/events.constant';
import authorizedCharges from '../config/authorized-charges';

const DEFAULT_RAIL_SERVICE_PROVIDER = 'Tube';

export default function TripCheckoutAllocationController(
    $scope,
    $rootScope,
    $stateParams,
    tripFactory,
    userService,
    l10nService,
    travellerUtils,
    hotelsFactory,
    checkoutAllocationService,
    screenDetectionService,
    seatmapAvailabilityService
) {
    'ngInject';

    const regionalSettings = userService.getRegionalSettings();

    const vm = this;
    let isInvoicePaymentMethod = false;

    const localizedAuthorizedCharges = getLocalizedAuthorizedCharges();
    Object.assign(vm, {
        $onInit,
        getRailServiceProvider,
        localizedAuthorizedCharges,
        isAuthorizedChargesVisible,
        regionalSettings,
        isSeatmapAvailableForFlightRecommendation: seatmapAvailabilityService.isSeatmapAvailableForFlightRecommendation,
    });

    function $onInit() {
        $scope.flights = getFlights();
        $scope.hotels = _.each($scope.tripDetails.Hotels, getAllocatedTraveller);
        $scope.cars = _.each($scope.tripDetails.Cars, (item) => getAllocatedTraveller(item, 'Select driver'));
        $scope.euRails = _.each($scope.tripDetails.EuRails, (item) => getAllocatedTraveller(item, 'Select lead passenger'));
        $scope.rails = checkoutAllocationService.processRails($scope.tripDetails.Rails);
        vm.isHoldDeadlineMessageVisible = isHoldDeadlineMessageVisible();
        $scope.hideAnyVacantSeatLabel = hideAnyVacantSeatLabel;
    }

    function getLocalizedAuthorizedCharges() {
       return authorizedCharges.map((value) => ({label: l10nService.localize(value.label), id: value.id}));
    }

    function getFlights() {
        return _.each($scope.tripDetails.Flights, (flight) => {
            const flightCodes = [];
            const lastFlightGroup = flight.FlightGroups[flight.FlightGroups.length - 1];
            _.each(flight.FlightGroups, function(group) {
                _.each(
                    group.Flights, function(groupFlight) {
                        flightCodes.push(groupFlight.DepartureAirportCode);
                    }
                );
            });

            flightCodes.push(lastFlightGroup.Flights[lastFlightGroup.Flights.length - 1].ArrivalAirportCode);
            flight.CodesString = flightCodes.join(' - ');
            flight.holdDate = (flight.HoldUntil)
                ? moment(flight.HoldUntil).format(regionalSettings.shortDayMonthDateFormatMoment)
                : false;
        });
    }

    function isInvoicePaymentMethodSelected() {
        return (isInvoicePaymentMethod || $scope.$parent.invoiceOnly.value);
    }

    function isAuthorizedChargesVisible(hotel) {
        return isInvoicePaymentMethodSelected() && hotelsFactory.isBillbackHotel(hotel);
    }

    function hasBillBackHotelAndInvoiceSelected() {
        return $scope.tripDetails.Hotels.some(hotelsFactory.isBillbackHotel) && isInvoicePaymentMethodSelected();
    }

    $scope.adults = travellerUtils.getAllocationAdults($scope.tripDetails.Travelers.Adult);

    const selectedAdults = {};

    $scope.$on(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE, $onInit);

    const updateAdultList = $scope.updateAdultList = function(hotel, roomIndex, selected, hotelIndex) {
        _.each(hotel.rooms, function(room, index) {
            // do nothing for current dropdown
            if (!room.charges) {
                room.charges = {};
            }

            if (roomIndex === index) {
                return;
            }

            // Restore previously selected value from current dropdown if there was one
            if (selectedAdults[hotelIndex + '_' + roomIndex]) {
                room.adults.push(selectedAdults[hotelIndex + '_' + roomIndex]);
            }

            //remove selected adult from other dropdowns
            room.adults = _.filter(room.adults, (adult) => adult.id !== selected.id);
        });

        //save selected adult for this position
        selectedAdults[hotelIndex + '_' + roomIndex] = selected;
    };

    function updateRoomAdultLists(tripItem) {
        for (let roomIndex = 0; roomIndex < tripItem.RoomQuantity; roomIndex++) {
            updateAdultList(tripItem, roomIndex, tripItem.rooms[roomIndex].user);
        }
    }

    function hideAnyVacantSeatLabel(seatPreferenceGroup) {
        return seatPreferenceGroup.Position
            || seatPreferenceGroup.Facilities
            || seatPreferenceGroup.Direction
            || seatPreferenceGroup.CarriageType
            || seatPreferenceGroup.SeatType
            || seatPreferenceGroup.Deck;
    }

    function getAllocatedTraveller(tripItem, genericTravellerPlaceholder) {
        const isSingleTraveller = ($scope.adults.length === 1);
        const travellerSpecified = (tripItem.RoomType)
            ? tripItem.LeadAllocationIds.length
            : tripItem.LeadAllocationId;

        function retrieveTraveller(travellerId) {
            return _.find($scope.adults, {id: travellerId});
        }

        function assignRoomTraveller(travellerName, travellerId) {
            tripItem.rooms.push({
                adults: angular.copy($scope.adults),
                user: {name: travellerName, id: travellerId},
            });
        }

        function assignGenericTraveller(travellerName, travellerId) {
            tripItem.user = {name: travellerName, id: travellerId};
        }

        function assignSingleTraveller(tripItemToAssign) {
            return (tripItemToAssign.RoomType)
                ? assignRoomTraveller($scope.adults[0].name, $scope.adults[0].id)
                : assignGenericTraveller($scope.adults[0].name, $scope.adults[0].id);
        }

        function assignTraveller(tripItemToAssign) {
            let traveller;
            let roomIndex;

            if (tripItemToAssign.RoomType) {
                for (roomIndex = 0; roomIndex < tripItemToAssign.RoomQuantity; roomIndex++) {
                    traveller = retrieveTraveller(tripItemToAssign.LeadAllocationIds[roomIndex]);

                    if (traveller) {
                        assignRoomTraveller(traveller.name, traveller.id);
                    } else {
                        assignRoomTraveller(l10nService.localize('Select lead traveller'), null);
                    }
                }
            } else {
                traveller = retrieveTraveller(tripItemToAssign.LeadAllocationId);
                assignGenericTraveller(traveller.name, traveller.id);
            }
        }

        function assignBlankTraveller(tripItemToAssign) {
            let roomIndex;

            if (tripItemToAssign.RoomType) {
                for (roomIndex = 0; roomIndex < tripItemToAssign.RoomQuantity; roomIndex++) {
                    assignRoomTraveller(l10nService.localize('Select lead traveller'), null);
                }
            } else {
                assignGenericTraveller(l10nService.localize(genericTravellerPlaceholder), null);
            }
        }

        if (tripItem.RoomType) {
            tripItem.rooms = [];
        }

        if (isSingleTraveller) {
            assignSingleTraveller(tripItem);
        } else if (travellerSpecified) {
            assignTraveller(tripItem);
        } else {
            assignBlankTraveller(tripItem);
        }

        if (tripItem.RoomType) {
            updateRoomAdultLists(tripItem);
        }
    }

    $scope.isBook = false;
    $scope.isHold = false;

    $scope.$on(tripEvents.TRIP_START_BOOK, () => {
        $scope.isBook = true;
        $scope.adults = angular.copy(travellerUtils.getAllocationAdults($scope.tripDetails.Travelers.Adult));
    });

    $scope.$on(tripEvents.TRIP_START_HOLD, () => {
        $scope.isHold = true;
        $scope.adults = angular.copy(travellerUtils.getAllocationAdults($scope.tripDetails.Travelers.Adult));
    });

    $scope.$on(tripEvents.TRIP_UPDATE_COSTS, (event, data) => {
        if (!data) {
            return;
        }
        isInvoicePaymentMethod = data.isInvoice;
    });

    $scope.$on(tripEvents.TRIP_CANCEL_CHECKOUT_PROCESS, () => {
        $scope.isBook = false;
        $scope.isHold = false;
    });

    $scope.isTravelersAllocationVisible = function() {
        if (($stateParams.rebook && $stateParams.rebook.isEuRails) || $scope.tripDetails.IsOfflineTrip) {
            return false;
        }
        return $scope.isFlightAllocationVisible()
            || $scope.isHotelAllocationVisible()
            || $scope.isEuRailAllocationVisible();
    };

    $scope.isFlightAllocationVisible = function() {
        function visibleForFlightsOnBooking() {
            return $scope.isBook
                && (!!$scope.adults.length)
                && (!!$scope.tripDetails.Flights.length)
                && isSeatmapAvailableForAtLeastOneFlight()
                && !screenDetectionService.isMobile();
        }

        function visibleForFlightsOnHolding() {
            return $scope.isHold
                && (!!$scope.adults.length)
                && (!!$scope.tripDetails.Flights.length);
        }
        return visibleForFlightsOnBooking()
            || visibleForFlightsOnHolding();
    };

    $scope.isHotelAllocationVisible = function() {
        function visibleForHotels() {
            return ($scope.adults.length > 1)
                && (!!$scope.hotels.length || !!$scope.cars.length);
        }
        return (isBookable() && visibleForHotels())
            || isHoldable()
            || hasBillBackHotelAndInvoiceSelected();
    };

    $scope.isEuRailAllocationVisible = function() {
        return !!$scope.euRails.length;
            //&& $scope.adults.length > 1;
    };

     function isSeatmapAvailableForAtLeastOneFlight() {
          return $scope.tripDetails.Flights
              .some(seatmapAvailabilityService.isSeatmapAvailableForFlightRecommendation);
     }

    function isBookable() {
        return $scope.isBook;
    }

    function isHoldable() {
        return $scope.isHold;
    }

    $scope.checkAllocation = function() {
        return tripFactory.validateAllocation([$scope.hotels, $scope.cars]);
    };

    $scope.showHoldMessageForRail = function() {
        return (!$scope.flights.length && !$scope.cars.length && !$scope.hotels.length && $scope.rails.length);
    };

    $rootScope.$broadcast(tripEvents.TRIP_REFRESH);

    function isHoldDeadlineMessageVisible() {
        return $scope.flights.filter((flight) => flight.HoldUntil).length > 1;
    }

    function getRailServiceProvider(recommendation) {
        if (!(recommendation.RailGroups && recommendation.RailGroups.length)) {
            return DEFAULT_RAIL_SERVICE_PROVIDER;
        }
        const [group] = recommendation.RailGroups;
        if (!(group.Rails && group.Rails.length)) {
            return DEFAULT_RAIL_SERVICE_PROVIDER;
        }
        const [rail] = group.Rails;
        return rail.ServiceProvider
            || DEFAULT_RAIL_SERVICE_PROVIDER;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/allocation/trip-checkout-allocation-controller.js